import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ArpioSharedModule } from '../shared/arpio-shared.module'
import { AzureMarketplaceErrorComponent } from './components/azure-marketplace-error/azure-marketplace-error.component'
import { AzureMarketplaceComponent } from './components/azure-marketplace/azure-marketplace.component'
import { AzureMarketplaceSelectLinkedAccountComponent } from './components/azure-marketplace-select-linked-account/azure-marketplace-select-linked-account.component'

@NgModule({
  declarations: [
    AzureMarketplaceComponent,
    AzureMarketplaceSelectLinkedAccountComponent,
    AzureMarketplaceErrorComponent,
  ],
  imports: [CommonModule, ArpioSharedModule],
})
export class AzureMarketplaceModule {}
